import React from 'react'

import S from './styled'

const Button = ({ children, progress, ...props }) => <S.Button className={progress ? 'progress' : ''} {...props}>{children}</S.Button>

export default Button
